import React from 'react';
import './Privacy.css';

const Privacy = () => {
  return (
    <section className="section privacy-page" aria-label="Privacy Policy">
      <div className="container">
        <div className="section-card">
          <h2 className="section-title-center">Privacy Policy</h2>
          <p className="section-subtitle-center">Kajun Kitchen — Small Batch Kajun Seasonings</p>

          <div className="privacy-content">
            <p>We value your privacy. This site collects only the information necessary to process orders and respond to inquiries (name, email, shipping address, and payment details). We do not sell your personal data.</p>
            <p>We use industry-standard measures to protect payment information. For more details, contact us at <a href="mailto:Rfloyd@kajunkitchen.net">Rfloyd@kajunkitchen.net</a>.</p>
            <p>By using this site you agree to our terms of service and the storage/processing described above. If you have questions or requests about your personal data, please contact us.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Privacy;
